var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.489,
    height: 47.489,
    viewBox: "0 0 47.489 47.489",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.532,13.913H36.358V6.956A6.964,6.964,0,0,0,29.4,0H6.956A6.964,6.964,0,0,0,0,6.956V20.869a6.968,6.968,0,0,0,5.565,6.816V32a1.391,1.391,0,0,0,2.163,1.158l3.4-2.268v3.893a6.964,6.964,0,0,0,6.956,6.956H31.752l7.991,5.5a1.391,1.391,0,0,0,2.18-1.146V41.6a6.968,6.968,0,0,0,5.565-6.816V20.869A6.964,6.964,0,0,0,40.532,13.913ZM6.956,25.043a4.179,4.179,0,0,1-4.174-4.174V6.956A4.179,4.179,0,0,1,6.956,2.783H29.4a4.179,4.179,0,0,1,4.174,4.174V20.869A4.179,4.179,0,0,1,29.4,25.043H15.3a1.39,1.39,0,0,0-.772.234L8.348,29.4V26.434A1.391,1.391,0,0,0,6.956,25.043Zm37.75,9.739a4.179,4.179,0,0,1-4.174,4.174,1.391,1.391,0,0,0-1.391,1.391v3.1L32.974,39.2a1.391,1.391,0,0,0-.789-.246h-14.1a4.179,4.179,0,0,1-4.174-4.174V29.034l1.813-1.208H29.4a6.964,6.964,0,0,0,6.956-6.956V16.7h4.174a4.179,4.179,0,0,1,4.174,4.174Zm0,0",
    fill: "#f90e0e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.391,77.783h11.316a1.391,1.391,0,1,0,0-2.783H91.391a1.391,1.391,0,0,0,0,2.783Zm0,0",
    transform: "translate(-81.652 -68.044)",
    fill: "#f90e0e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.391,137.783h11.316a1.391,1.391,0,0,0,0-2.783H91.391a1.391,1.391,0,1,0,0,2.783Zm0,0",
    transform: "translate(-81.652 -122.479)",
    fill: "#f90e0e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.391,197.783h16.881a1.391,1.391,0,1,0,0-2.783H91.391a1.391,1.391,0,0,0,0,2.783Zm0,0",
    transform: "translate(-81.652 -176.914)",
    fill: "#f90e0e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M274.783,76.391A1.391,1.391,0,1,1,273.391,75,1.391,1.391,0,0,1,274.783,76.391Zm0,0",
    transform: "translate(-246.772 -68.044)",
    fill: "#f90e0e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M274.783,136.391A1.391,1.391,0,1,1,273.391,135,1.391,1.391,0,0,1,274.783,136.391Zm0,0",
    transform: "translate(-246.772 -122.479)",
    fill: "#f90e0e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M230.086,345h-16.7a1.391,1.391,0,0,0,0,2.783h16.7a1.391,1.391,0,0,0,0-2.783Zm0,0",
    transform: "translate(-192.337 -313.001)",
    fill: "#f90e0e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.95d270615a8a161b71e16969a3afbf8d.svg";
export { ForwardRef as ReactComponent };